import * as yup from "yup";
import errors from "venuescanner-js/react/components/Form/copy/errors";

const dateRangeValidation = yup
  .array()
  .test(
    "twoDatesRequired",
    "Both start and end dates are required",
    twoDatesRequired
  )
  .test(
    "areDatesInThePresentOrFuture",
    "Event dates are in the past",
    areDatesInThePresentOrFuture
  );

export default yup.object().shape({
  capacity: yup
    .number()
    .typeError(errors.default.number)
    .required(errors.default.requiredShort)
    .min(1, "The event has no guests"),
  dateRange: dateRangeValidation,
  start: yup.string().required(errors.default.requiredShort),
  end: yup.string().required(errors.default.requiredShort),
});

function twoDatesRequired(dates, _context) {
  return dates.filter((date) => !!date).length === 2;
}

function areDatesInThePresentOrFuture([startDate, endDate], _context) {
  const now = new Date();

  return startDate >= now || endDate >= now;
}
